"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingManager = void 0;
var floating_item_1 = require("./floating-item");
var floating_item_data_1 = require("./floating-item-data");
var preset_manager_1 = require("./preset-manager");
var preact_1 = require("preact");
var player_utils_1 = require("./player-utils");
var managed_component_1 = require("./managed-component");
var presets_utils_1 = require("./presets-utils");
var contrib_utils_1 = require("./contrib-utils");
var defaultFloatingConfig = {
    presetAreasMapping: {
        Playback: {
            VideoArea: 'VideoArea',
            PresetArea: 'PresetArea',
            InteractiveArea: 'InteractiveArea',
        },
        Live: {
            VideoArea: 'VideoArea',
            PresetArea: 'PresetArea',
            InteractiveArea: 'InteractiveArea',
        },
    },
};
var acceptableTypes = ['VideoArea', 'PresetArea', 'InteractiveArea'];
var FloatingManager = /** @class */ (function () {
    function FloatingManager(_options) {
        var _a, _b;
        var _this = this;
        this._options = _options;
        this._items = (_a = {},
            _a[floating_item_data_1.FloatingPositions.VideoArea] = [],
            _a[floating_item_data_1.FloatingPositions.InteractiveArea] = [],
            _a[floating_item_data_1.FloatingPositions.PresetArea] = [],
            _a);
        this._componentRef = (_b = {},
            _b[floating_item_data_1.FloatingPositions.InteractiveArea] = null,
            _b[floating_item_data_1.FloatingPositions.VideoArea] = null,
            _b[floating_item_data_1.FloatingPositions.PresetArea] = null,
            _b);
        this._cache = {
            canvas: {
                playerSize: { width: 0, height: 0 },
                videoSize: { width: 0, height: 0 },
            },
        };
        this._renderItems = function (position) {
            var props = _this._getRendererProps({});
            return _this._items[position].map(function (item) { return item.renderFloatingChild(props); });
        };
        this._renderChild = function (position) {
            return ((0, preact_1.h)(managed_component_1.ManagedComponent, { label: 'floating-manager', renderChildren: function () { return _this._renderItems(position); }, isShown: function () { return true; }, ref: function (ref) { return (_this._componentRef[position] = ref); } }));
        };
        this._floatingConfig = (0, contrib_utils_1.getContribConfig)(this._options.kalturaPlayer, 'ui.floating', defaultFloatingConfig, {
            explicitMerge: ['presetAreasMapping'],
        });
        var groupedPresets = presets_utils_1.PresetsUtils.groupPresetAreasByType({
            presetAreasMapping: this._floatingConfig.presetAreasMapping,
            acceptableTypes: acceptableTypes,
        });
        Object.keys(groupedPresets).forEach(function (presetType) {
            _this._options.presetManager.add({
                label: 'floating-manager',
                presetAreas: groupedPresets[presetType],
                // @ts-ignore
                renderChild: function () { return _this._renderChild(floating_item_data_1.FloatingPositions[presetType]); },
            });
        });
        this._addPlayerBindings();
        this._updateCachedCanvas();
    }
    /**
     * initialize new floating ui item
     * @param item
     */
    //TODO push new item to relevant position array according to its' FloatingPositions value
    FloatingManager.prototype.add = function (data) {
        var presetManager = this._options.presetManager;
        var itemOptions = __assign(__assign({ 
            // @ts-ignore
            presetManager: presetManager }, this._options), { data: data });
        var item = new floating_item_1.FloatingItem(itemOptions);
        this._items[data.position].push(item);
        return item;
    };
    FloatingManager.prototype.remove = function (item) {
        var positionItems = this._items[item.data.position];
        var itemIndex = positionItems.indexOf(item);
        if (itemIndex > -1) {
            positionItems[itemIndex].destroy();
            positionItems.splice(itemIndex, 1);
        }
        else {
            console.warn("couldn't remove ".concat(item, " since it wasn't found"));
        }
    };
    FloatingManager.prototype.reset = function () {
        var allItems = __spreadArray(__spreadArray(__spreadArray([], this._items.VideoArea, true), this._items.InteractiveArea, true), this._items.PresetArea, true);
        allItems.forEach(function (item) {
            try {
                item.destroy();
            }
            catch (e) {
                // TODO log error
                console.warn(e);
            }
        });
        this._items.VideoArea = [];
        this._items.PresetArea = [];
        this._items.InteractiveArea = [];
    };
    FloatingManager.prototype._getRendererProps = function (props) {
        var kalturaPlayer = this._options.kalturaPlayer;
        return {
            currentTime: typeof props.currentTime !== 'undefined'
                ? props.currentTime
                : kalturaPlayer.currentTime * 1000,
            canvas: this._cache.canvas,
        };
    };
    FloatingManager.prototype._updateCachedCanvas = function () {
        this._cache.canvas = {
            playerSize: (0, player_utils_1.getPlayerSize)(this._options.kalturaPlayer),
            videoSize: (0, player_utils_1.getVideoSize)(this._options.kalturaPlayer),
        };
    };
    FloatingManager.prototype._updateComponents = function () {
        if (this._componentRef.InteractiveArea) {
            this._componentRef.InteractiveArea.update();
        }
        if (this._componentRef.PresetArea) {
            this._componentRef.PresetArea.update();
        }
        if (this._componentRef.VideoArea) {
            this._componentRef.VideoArea.update();
        }
    };
    FloatingManager.prototype._addPlayerBindings = function () {
        var _this = this;
        var kalturaPlayer = this._options.kalturaPlayer;
        kalturaPlayer.addEventListener(kalturaPlayer.Event.TIME_UPDATE, function () {
            _this._updateComponents();
        });
        kalturaPlayer.addEventListener(kalturaPlayer.Event.MEDIA_LOADED, function () {
            _this._updateCachedCanvas();
            _this._updateComponents();
        });
        kalturaPlayer.addEventListener(kalturaPlayer.Event.LOADED_DATA, function () {
            _this._updateCachedCanvas();
            _this._updateComponents();
        });
        this._options.presetManager.on(preset_manager_1.PresetManagerEventTypes.VideoResizeEvent, function () {
            _this._updateCachedCanvas();
            _this._updateComponents();
        });
        this._options.presetManager.on(preset_manager_1.PresetManagerEventTypes.PresetResizeEvent, function () {
            _this._updateCachedCanvas();
            _this._updateComponents();
        });
    };
    return FloatingManager;
}());
exports.FloatingManager = FloatingManager;
//# sourceMappingURL=floating-manager.js.map